function isPeriod(value) {
  return /^\d{4}-\d{2}$/.test(value || '');
}

function nextPeriod(period) {
  const date = new Date(Number(period.slice(0, 4)), Number(period.slice(5, 7)), 1);
  return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}`;
}

function periodsFrom(start, end) {
  const periods = [];
  let cursor = start;
  while (cursor <= end) {
    periods.push(cursor);
    cursor = nextPeriod(cursor);
  }
  return periods;
}

export function getPayrollSummary(employee, period, payments = []) {
  const currentSalary = Number(employee?.salary || 0);
  const employeePayments = payments.filter((payment) => payment.employeeId === employee?.id && isPeriod(payment.salaryPeriod));
  const firstPeriod = employeePayments.map((payment) => payment.salaryPeriod).sort()[0];

  // The first recorded salary month is the employee's payroll baseline.
  if (firstPeriod && period < firstPeriod) {
    return { salary: currentSalary, carriedForward: 0, totalDue: 0, paidToDate: 0, paidThisPeriod: 0, remaining: 0 };
  }

  // If there is no history, the selected month becomes the starting month
  // when the first payment is recorded.
  const startPeriod = firstPeriod || period;
  const payablePeriods = periodsFrom(startPeriod, period);
  const rateForPeriod = (payrollPeriod) => {
    const periodPayments = employeePayments.filter((payment) => payment.salaryPeriod === payrollPeriod);
    const recordedRate = periodPayments.find((payment) => Number(payment.salaryRate || 0) > 0)?.salaryRate;
    if (recordedRate) return Number(recordedRate);
    // Salary is the source of truth. Payment amounts only reduce the amount
    // owed; they must never be used to infer the employee's salary.
    return currentSalary;
  };
  const totalDue = payablePeriods.reduce((sum, payrollPeriod) => sum + rateForPeriod(payrollPeriod), 0);
  const paidToDate = employeePayments
    .filter((payment) => payment.salaryPeriod <= period)
    .reduce((sum, payment) => sum + Number(payment.amount || 0), 0);
  const paidBeforePeriod = employeePayments
    .filter((payment) => payment.salaryPeriod < period)
    .reduce((sum, payment) => sum + Number(payment.amount || 0), 0);
  const dueBeforePeriod = payablePeriods
    .filter((payrollPeriod) => payrollPeriod < period)
    .reduce((sum, payrollPeriod) => sum + rateForPeriod(payrollPeriod), 0);
  const paidThisPeriod = employeePayments
    .filter((payment) => payment.salaryPeriod === period)
    .reduce((sum, payment) => sum + Number(payment.amount || 0), 0);

  return {
    salary: currentSalary,
    carriedForward: Math.max(dueBeforePeriod - paidBeforePeriod, 0),
    totalDue,
    paidToDate,
    paidThisPeriod,
    remaining: Math.max(totalDue - paidToDate, 0),
  };
}
